define([
	"dojo/_base/declare",
	"csi/table/Copy",
	"Specification",
	"Specification/BOM/BOMSupplierAttributesMixin"
], function(declare,Copy,Specification,BOMSupplierAttributesMixin) {

	return declare([Copy, BOMSupplierAttributesMixin], {
		onStart: function() {
			this.idOwnerRelation = "Items";
		}
	});
});